/*
 * Copyright (c) Nexign, JSC, 2025.
 */
/**
 *
 *
 * @author Julia Ignatieva
 * @version 1.37.0
 * @since 1.37.0
 */

import { createAction } from '@modules/app/createAction';

import {
    IWizardChangeRoleSetStepValidPayload,
    TWizardChangeRoleHandleNextAction,
    TWizardChangeRoleSetParamsAction,
    TWizardChangeRoleSetParamsPayload,
    TWizardChangeRoleSetStepValidAction,
    TWizardChangeRoleStartValidateAction,
} from './types/wizardChangeRoleActionTypes';
import {
    WIZARD_CHANGE_ROLE_HANDLE_NEXT,
    WIZARD_CHANGE_ROLE_SET_PARAMS,
    WIZARD_CHANGE_ROLE_SET_STEP_VALID,
    WIZARD_CHANGE_ROLE_START_VALIDATE,
} from './wizardChangeRoleConstant';

/*
* -------------------------------------------
*         Common Wizard Actions
* -------------------------------------------
*/

export const wizardChangeRoleHandleNextAction = (): TWizardChangeRoleHandleNextAction =>
    createAction(WIZARD_CHANGE_ROLE_HANDLE_NEXT);

export const wizardChangeRoleSetParamsAction = (payload: TWizardChangeRoleSetParamsPayload):
    TWizardChangeRoleSetParamsAction =>
    createAction(WIZARD_CHANGE_ROLE_SET_PARAMS, payload);

export const wizardChangeRoleStartValidateAction = ():
    TWizardChangeRoleStartValidateAction => createAction(WIZARD_CHANGE_ROLE_START_VALIDATE);

export const wizardChangeRoleSetStepValidAction = (payload: IWizardChangeRoleSetStepValidPayload):
    TWizardChangeRoleSetStepValidAction => createAction(WIZARD_CHANGE_ROLE_SET_STEP_VALID, payload);
